module.exports = __webpack_public_path__ + "img/img_sub_ser_transformation_07.d6a09108.svg";